export const cx = (...xs) => xs.filter(Boolean).join(" ");

export const ui = {
  page: "min-h-screen bg-ink text-white",
  center: "min-h-screen bg-ink text-white grid place-items-center px-4",
  container: "mx-auto max-w-xl px-4 py-4 pb-[calc(16px+env(safe-area-inset-bottom))]",
  card: "rounded-3xl border border-line bg-panel shadow-soft",
  cardPad: "p-5",
  h1: "text-xl font-black tracking-tight",
  muted: "text-sm text-white/70 leading-relaxed",
  label: "text-xs font-bold text-white/70",
  input:
    "w-full rounded-xl border border-line2 bg-black/10 px-3 py-2 text-white placeholder:text-white/35 outline-none focus:border-otter/70 focus:ring-2 focus:ring-otter/20",
  btn:
    "inline-flex items-center justify-center rounded-xl border border-line2 px-4 py-2 font-black tracking-tight transition active:scale-[0.99]",
  btnPrimary:
    "bg-gradient-to-r from-otter to-otter2 text-black border-transparent hover:opacity-95",
  btnGhost: "bg-transparent text-white/85 hover:bg-white/5",
  pill: "rounded-full border border-line2 bg-white/5 px-3 py-1 text-xs font-bold text-white/80",
};
